import React from 'react'
import styled from 'styled-components'
import { ThemeColor } from 'theme/colors'
import { AlertVariant } from '../alert/context'
import { Flex } from '../containers/flex'
import { Icon } from '../icon'
import { getIcon } from '../icon/alert/alert-icon'
import { Small } from '../typography'

export const getAlertMessageColor = (variant: AlertVariant): ThemeColor => {
  switch (variant) {
    case 'error':
      return 'error130'
    case 'info':
      return 'secondary130'
    case 'warn':
      return 'warn130'
    case 'success':
    default:
      return 'success130'
  }
}

export const getBrightAlertColor = (variant: AlertVariant): ThemeColor => {
  switch (variant) {
    case 'error':
      return 'error110'
    case 'info':
      return 'secondary110'
    case 'warn':
      return 'warn110'
    case 'success':
    default:
      return 'success110'
  }
}

const StyledAlertText = styled.div``
type AlertTextProps = {
  variant: AlertVariant
  message: string
}

export const AlertText = ({ variant, message }: AlertTextProps) => {
  return (
    <StyledAlertText>
      <Flex flexDirection="row">
        <Icon
          type={getIcon(variant)}
          color={getBrightAlertColor(variant)}
          size="s16"
        />
        <Small pl="s8" pr="s8" color={getAlertMessageColor(variant)}>
          {message}
        </Small>
      </Flex>
    </StyledAlertText>
  )
}
